export default function CustomerImportValidationTable({ summary }) {
  if (!summary) return null;

  const items = [
    { label: "Totaal", value: summary.totalRows || 0 },
    { label: "Geldig", value: summary.validRows || 0 },
    { label: "Waarschuwingen", value: summary.warningRows || 0 },
    { label: "Fouten", value: summary.errorRows || 0 },
    { label: "Exact dubbel", value: summary.exactDuplicateRows || 0 },
    { label: "Mogelijk dubbel", value: summary.possibleDuplicateRows || 0 },
  ];

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900">3. Validatie-overzicht</h3>
      <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-3">
        {items.map((item) => (
          <div key={item.label} className="rounded-lg border border-slate-200 bg-slate-50 p-3">
            <p className="text-xs uppercase tracking-wide text-slate-500">{item.label}</p>
            <p className="mt-1 text-lg font-semibold text-slate-900">{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
